<script>
  import EmptyState from '../../EmptyState/EmptyState.vue';
  import Loading from '../../Loading/Loading.vue';

  export default {
    name: 'loading-manager',

    components: {
      EmptyState,
      Loading,
    },

    props: {
      emptyStateText: {
        type: String,
        default: '',
      },

      loading: Boolean,

      results: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<template>
  <Loading v-if="loading" class="bg-white" />
  <transition-group v-else-if="results.length" name="slide-y" tag="ul">
    <slot></slot>
  </transition-group>
  <EmptyState v-else class="max-w-full bg-white" :text="emptyStateText" />
</template>
